import React from 'react';

const StringConstantsMixin = {
  strings: {
    // utility to translate words in minfied JS
    START_TRANSLATE: 'START_TRANSLATE',
    CLOSE: 'Close',
    SORT_ALONE: 'Sort',
    EXPAND_MAP: 'Expand map',
    SUCCESS: 'Success',
    CHAT: 'Chat',
    TRAILS: 'Trails',
    NEAR: 'near',
    THAT_MATCH: 'that match',
    SENT: 'Sent',
    ICON: 'Icon',
    SEARCH_WORD: 'Search',
    REQUIRED: 'Required',
    LIST_COPY: 'Copy to my Lists',
    LIST_COPY_IN_PROGRESS: 'Copying...',
    LIST_COPY_SUCCESS: 'Successfully Copied',
    CLEAR_FILTERS: 'Clear filters',
    NO_RESULTS: 'No Results.',
    NO_MAPS: 'No Maps.',
    MAP_LAYERS: 'Map layers',
    MAP_OVERLAYS: 'Overlays',
    DIRECTIONS: 'Directions',
    PRINT_MAP: 'Print map',
    PDF_MAP: 'PDF Map',
    START: 'start',
    END: 'end',
    USER_AVATAR_ALT: `View user's profile page`,
    PRINT_PDF_MAP: 'Print/PDF Map',
    NO_RECORDINGS: 'No Recordings.',
    NO_TRAILS_IN_LIST: 'No trails in list.',
    TOTAL: 'Total',
    DELETE_LIST_QUESTION: 'Are you sure you want to delete this list?',
    DELETE_ITEM_QUESTION: 'Are you sure you want to delete this from AllTrails?',
    TRAILS_NEAR: 'Trails near: ',
    FIND_NEARBY_TRAILS: 'Find Nearby Trails',
    MY_MAPS: 'My Maps',
    MY_MAP: 'My Map',
    MAP: 'Map',
    RECORDING: 'Recording',
    STATUS: 'Status',
    MY_RECORDINGS: 'My Recordings',
    MY_ACCOUNT: 'My Account',
    MORE_TRAILS: 'More Trails',
    VIEW_TRAIL_DETAILS: 'View Trail Details',
    VIEW_LIST_DETAILS: 'View List Details',
    VIEW_FULL_MAP: 'View Full Map',
    EXPLORE_TRAILS: 'Explore Trails',
    PHOTOS: 'photos',
    PHOTO: 'Photo',
    WAYPOINT: 'Waypoint',
    NEW_WAYPOINT: 'New Waypoint',
    EDIT_WAYPOINT: 'Edit Waypoint',
    ADD_NEW_WAYPOINT: 'Add new waypoint',
    DRAG_TO_DESIRED_LOCATION: 'Drag to desired location',
    LOCATION: 'Location',
    LISTS: 'Lists',
    LIST: 'List',
    PRIVATE_LIST: 'Private List',
    PUBLIC_LIST: 'Public List',
    PRIVATE_UPPER_CASE: 'PRIVATE',
    TITLE: 'Title',
    SHARE_YOUR_ROUTE: 'Share your route with others',
    RECORDINGS_HELP_OTHERS: 'Recordings help other users find their next route. Upload your recording and inspire others.',
    ADD_YOUR_PHOTOS: 'Add photos of this trail',
    PHOTOS_HELP_OTHERS: 'Photos help others preview the trail. Upload photos about this trail to inspire others.',
    JOIN_THE_LIST: 'Join the list',
    USE_RECORDER_ZERO: 'Use Recorder in the AllTrails app and be the first outdoor explorer who has completed this trail.',
    USE_RECORDER_SINGULAR: 'Use Recorder in the AllTrails app and join the other outdoor explorer who has completed this trail.',
    USE_RECORDER_PLURAL: 'Use Recorder in the AllTrails app and join the {completedCount} other outdoor explorers who have completed this trail.',
    HOW_WAS_TRAIL: 'How was {trailName}?',
    VIEW_USERS_RECORDING: "View {userName}'s Recording",
    REVIEW_SINGULAR: '1 Review',
    REVIEWS_PLURAL: '{count} Reviews',
    FIRST_TO_REVIEW: 'First to Review',
    RECORDING_NAME: 'Recording name',
    NOTES: 'Notes',
    ADD_A_CAPTION: 'Add a caption',
    CAPTION: 'Caption',
    KEEP_NOTES: 'Keep notes about your recording here.',
    WHAT_WERE_YOU_DOING: 'What were you doing?',
    HOW_WAS_IT: 'How was it out there?',
    SEND_TO_MY_PHONE: 'Send to my phone',
    ADD_NEW_LIST: 'Add new list',
    OR: 'or',
    BACK: 'Back',
    CLEAR: 'Clear',
    CANCEL: 'Cancel',
    CANCEL_EDIT: 'Cancel Edit',
    SUBMIT: 'Submit',
    MERGE: 'Merge',
    MOVE: 'Move',
    SAVE: 'Save',
    SAVED: 'Saved',
    SAVING: 'Saving...',
    UPLOAD: 'Upload',
    UPLOAD_ERROR: 'Upload error',
    SMOOTH_FILE: 'Smooth file',
    EDIT: 'Edit',
    COMMENT: 'Comment',
    REMOVE: 'Remove',
    DONE: 'Done',
    DELETE: 'Delete',
    FAILED: 'Failed',
    HELP: 'Help',
    ERROR_OCCURRED: 'Error occurred',
    ERR_TRY_AGAIN: 'Error, please try again',
    MAPBOXGL_NOT_SUPPORTED:
      'It appears that your browser does not support MapboxGL, a library that is required to render maps on AllTrails.com. Please upgrade or change browsers before reloading the page. See https://docs.mapbox.com/help/troubleshooting/mapbox-browser-support/ for more details. Contact customer support with details about your device and browser if issue persists.',
    ADD: 'Add',
    MORE: 'More',
    SHARE: 'Share',
    SHARE_MAP: 'Share map',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    REORDER: 'Reorder',
    SUGGEST: 'Suggest',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    FAVORITE: 'Favorite',
    FAVORITED: 'Favorited',
    SAVE_FAVORITE: 'Save to your favorites',
    SAVE_CHANGES: 'Save Changes',
    MORE_MAPS: 'More Maps',
    MORE_RECORDINGS: 'More Recordings',
    MORE_PHOTOS: 'More Photos',
    ALL_PHOTOS: 'All Photos',
    MORE_OPTIONS: 'More options',
    THANK_YOU: 'Thank you',
    SUGGEST_TRAIL_DESCRIPTION: 'Suggest trail description',
    SUGGEST_EDIT: 'Suggest Edit',
    SET_AS_ROUTE: 'Set as Route',
    SUGGEST_AS_ROUTE: 'Suggest as Route',
    SUGGEST_AS_ROUTE_LOWER: 'Suggest as route',
    CREATE_LIST: 'Create new list',
    CREATE: 'Create',
    SETTING: 'Setting...',
    DELETING: 'Deleting...',
    REMOVING: 'Removing...',
    SUGGESTING: 'Suggesting...',
    DELETED: 'Deleted',
    REMOVED: 'Removed',
    SET: 'Set',
    RECORDED: 'recorded',
    ROUTE_SET: 'Route set',
    FAILED_RETRY: 'Failed, retry?',
    SEE_ALL: 'See All',
    TOP: 'Top',
    RATING: 'Rating',
    PRIVATE: 'Private',
    REVIEW: 'Review',
    ACTIVITY: 'Activity',
    ACTIVITY_DATE: 'Activity Date',
    SUPPORT_EMAIL: 'support@alltrails.com',
    ON: 'on',
    REVIEWED: 'reviewed',
    TRAIL_CONDITIONS: 'Trail Conditions',
    SHOW_ORIGINAL: 'Show Original',
    SHOW_TRANSLATION: 'Show Translation',
    SAVE_TO: 'Save to',
    APPLY: 'Apply',
    RESET: 'Reset',
    SEE_RESULTS: 'See results ({resultsCount})',
    FILTER: 'Filter',
    INVALID_LATITUDE: 'Invalid Latitude',
    INVALID_LONGITUDE: 'Invalid Longitude',
    SUNSET: 'Sunset',
    SUNRISE: 'Sunrise',
    UPLOADING: 'Uploading',
    SELECT_LANGUAGE: 'Select language',
    TIME: {
      MULTI_DAY: 'Multi-day'
    },
    ALT_TEXT: {
      CARET: 'Caret',
      YELLOW_STAR: 'Yellow Star',
      GRAY_STAR: 'Gray Star'
    },
    TRAIL_FORM_SUCCESS: {
      THANKS_FOR_REVIEW: 'Thanks for your review',
      COMMUNITY_RELIES: 'The community relies on great reviews like yours.',
      PHOTOS_UPLOADED: 'Photos uploaded',
      YOURE_HELPING: 'You’re helping the community preview trails.',
      KEEP_SNAPPING_SHARING: 'Keep snapping and sharing!',
      KEEP_EM_COMING: 'Keep ’em coming!',
      RECORDING_UPLOADED: 'Recording uploaded',
      FIND_NEW_ROUTES: "You're helping the community find new routes.",
      KEEP_EXPLORING: 'Keep exploring!',
      ROUTE_UPLOADED: 'Route uploaded',
      ROUTE_ADDED: 'Route has been added to your map.',
      KEEP_CREATING: 'Keep creating!'
    },
    SEARCH: {
      MAX_NUM_RESULTS: '1000+',
      SEARCH_FAVORITE_TRAILS: 'Search favorite trails...',
      SEARCH_COMPLETED_TRAILS: 'Search completed trails...',
      SEARCH_FOR_TRAILS: 'Searching for trails...',
      SHOWING_TRAIL_OF: 'Showing {amount} of {total} trails',
      SHOWING_TRAIL_OF_1: 'Showing {amount} of {total} trail',
      SHOWING_ITEM_OF: 'Showing {amount} of {total} items',
      SHOWING_ITEM_OF_1: 'Showing {amount} of {total} item',
      SHOWING_RECORDING_OF: 'Showing {amount} of {total} recordings',
      SHOWING_RECORDING_OF_1: 'Showing {amount} of {total} recording',
      SHOWING_MAP_OF: 'Showing {amount} of {total} maps',
      SHOWING_MAP_OF_1: 'Showing {amount} of {total} map',
      SHOWING_PARK_OF_IN: '#{amount} of {total} {parks} in {location}',
      SHOWING_AMOUNT_OF_TOTAL: 'Showing results {min} - {max} of {total}',
      SHOW_MORE_TRAILS: 'Show more trails',
      SHOW_MORE_PHOTOS: 'Show more photos',
      SHOW_MORE_REVIEWS: 'Show more reviews',
      SHOW_MORE_TRACKS: 'Show more recordings',
      SHOW_MORE_COMPLETED: 'Show more completed',
      MAP_OF_TRAILS_IN: 'Map of trails in',
      MAP_OF_TRAILS_NEAR: 'Map of trails near',
      CURRENT_LOCATION: 'Current Location',
      NO_ONE_REVIEWED: 'No one has reviewed this trail yet. Be the first!',
      NO_ONE_PHOTOS: 'No one has added photos of this trail yet. Be the first!',
      NO_ONE_RECORDED: 'No one has added a recording of this trail yet. Be the first!',
      NO_ONE_COMPLETED: 'No one has completed this trail yet. Be the first!',
      ZOOM_IN: 'Zoom Map In',
      ZOOM_OUT: 'Zoom Map Out',
      DID_YOU_MEAN: 'Did you mean...',
      SORRY_CANT_FIND: "Sorry we can't find",
      DONT_SEE: "Don't see what you're looking for?",
      CONTACT_US: 'Contact us.',
      PLEASE_TRY_AGAIN: 'Please try again',
      LOADING: 'Loading...',
      LOADING_NO_ELLIPSIS: 'Loading',
      LOAD_MORE: 'Load More',
      LOAD_MORE_TRAILS: 'Load More Trails',
      SEARCH_LIST: 'Search list...',
      SEARCH_RECORDINGS: 'Search Recordings...',
      SEARCH_MAPS: 'Search Maps...',
      TRAIL_LOAD: 'Hang in there while we search through 100,000+ trails to find the ones for you.',
      RECORDING_LOAD: 'Hang in there while we load your recordings.',
      MAP_LOAD: 'Hang in there while we load your maps.',
      MAP_LOAD_INFO: 'Loading Map Info...',
      TRAIL_LOAD_INFO: 'Loading Trail Info...',
      RECORDING_LOAD_INFO: 'Loading Recording Info...',
      MAP_LOAD_YOUR: 'Loading your maps...',
      RECORDING_LOAD_YOUR: 'Loading your recordings...',
      ADD_TO_FAVORITES: 'Add To Favorites',
      REMOVE_FROM_FAVORITES: 'Remove From Favorites',
      ADD_TO_COMPLETED: 'Add To Completed',
      REMOVE_FROM_COMPLETED: 'Remove From Completed',
      ADD_TO_LIST: 'Add To List',
      REMOVE_FROM_LIST: 'Remove From List',
      MAP_LOAD_MSG: 'Hang in there while we load more details about the map',
      TRAIL_LOAD_MSG: 'Hang in there while we load more details about the trail',
      RECORDING_LOAD_MSG: 'Hang in there while we load more details about the recording',
      SORTING_LOAD_MSG: 'Hang in there while we sort through all these',
      CLEAR_FILTERS_MORE_RESULTS: 'Clear your current search filters to see more results.',
      CLEAR_FILTERS_ALL_TRAILS: 'Clear your current search filters to see all trails.',
      CLEAR_FILTERS_ALL_MAPS: 'Clear your current search filters to see all maps.',
      CLEAR_FILTERS_ALL_RECORDINGS: 'Clear your current search filters to see all recordings.',
      FAVORITE_PROMPT: 'Tap the heart icon on any trail to add it to this list.',
      COMPLETION_PROMPT: "Keep a list of trails you've completed by checking in when you start.",
      RECORDER_PROMPT: 'Use the AllTrails Mobile apps to record your activities.',
      LIST_PROMPT: 'Search for trails to add to this list.',
      PLAN_PROMPT: 'Create a custom map using the AllTrails map creation tool',
      FIND_LOCATION: 'Find Location',
      ENTER_CITY_PARK_OR_LAT_LNG: 'Enter a city, park, or lat,long...',
      ENTER_CITY_PARK_OR_TRAIL_NAME: 'Enter a city, park or trail name',
      ENTER_MEMBERS_NAME: "Enter a member's name...",
      HIDE_NEARBY_TRAILS: 'Hide Nearby Trails',
      SHOW_NEARBY_TRAILS: 'Show Nearby Trails',
      CREATE_NEW_MAP: 'Create Map',
      COMMUNITY_CONTENT: 'Community Content',
      CURATED_TRAILS: 'Curated Trails',
      NO_RESULTS_FOUND: 'No Results Found',
      ENTER_AN_ADDRESS_CITY_PARK: 'Enter an address, city, park, or lat, long…',
      NO_RESULTS: {
        CURATED_TRAILS: {
          BUTTON: 'View Community Content',
          TITLE: {
            LONG: 'No Results Found',
            SHORT: 'Looking For More?'
          },
          BODY: {
            LONG: `Let's get you back on track! Adjust your filters or zoom out. You can also try the "Community Content" tab to see if others have explored here.`,
            SHORT: `Adjust your filters or zoom out. You can also try the "Community Content" tab to see if others have explored here.`
          }
        },
        COMMUNITY_CONTENT: {
          BUTTON: 'View Curated Trails',
          TITLE: {
            LONG: 'No Results Found',
            SHORT: 'Looking For More?'
          },
          BODY: {
            LONG: `Let's get you back on track! Adjust your filters or zoom out. You can also try the "Curated Trails" tab to see if others have explored here.`,
            SHORT: `Adjust your filters or zoom out. You can also try the "Curated Trails” tab to see trails in this area.`
          }
        }
      }
    },
    BREADCRUMB_ITEMS: {
      MEMBERS: 'Members',
      MAPS: 'Maps',
      RECORDINGS: 'Recordings',
      LIFELINE: 'Lifeline'
    },
    LOCATIONS: {
      CITY: 'City',
      REGION: 'Region'
    },
    MAP_LAYER_NAMES: {
      TERRAIN: 'Terrain',
      ROAD: 'Road',
      SATELLITE: 'Satellite',
      WORLD_PARKS: 'World parks'
    },
    MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    DAYS_OF_WEEK: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    // maintain case of NON_HOUR_TIMES keys for api updates
    NON_HOUR_TIMES: {
      CLOSED: 'closed',
      DAWN: 'dawn',
      DUSK: 'dusk'
    },
    TAB_NAMES: {
      DESCRIPTION: 'Description',
      OVERVIEW: 'Overview',
      WAYPOINTS: 'Waypoints',
      WEATHER: 'Weather',
      TIPS: 'Tips',
      GETTING_THERE: 'Getting There',
      FACILITIES: 'Facilities',
      CONTACT: 'Contact',
      PARK_INFO: 'Park Info',
      REVIEWS: 'Reviews',
      PHOTOS: 'Photos',
      RECORDINGS: 'Recordings',
      COMPLETED: 'Completed'
    },
    SEARCH_TAB_NAMES: {
      ALL: 'all',
      PLACES: 'places',
      PARKS: 'parks',
      TRAILS: 'trails',
      MAPS: 'maps',
      RECORDINGS: 'recordings',
      LISTS: 'lists'
    },
    PARK_INFO: {
      TITLE: 'Park information',
      WEBSITE: 'Website',
      PHONE_NUMBER: 'Phone number',
      HELPFUL_LINKS: 'Helpful links',
      PARK_HOURS: 'Park hours',
      NATIONAL_PARKS: 'national parks',
      STATE_PARKS: 'state parks',
      LOCAL_PARKS: 'local parks',
      AREA: 'Area',
      ACREAGE: 'Acreage',
      ACRES: 'acres',
      HECTARES: 'hectares',
      MAILING_ADDRESS: 'Mailing address',
      All_DAY: 'All day',
      COPY_TO_ALL: 'Copy to all',
      CLEAR_ALL: 'Clear all',
      OF: 'of',
      IN: 'in',
      TOP_TRAILS: 'Top trails',
      TOP_NATIONAL_PARKS: 'Top national parks',
      TOP_STATE_PARKS: 'Top state parks'
    },
    SORT: {
      atSort: 'AllTrails Sort',
      desc: 'Newest First',
      asc: 'Oldest First',
      highestRated: 'Highest Rated',
      lowestRated: 'Lowest Rated',
      SORT: 'Sort'
    },
    TRACK_DETAIL: {
      HIDE: 'Hide',
      UNHIDE: 'Unhide',
      AS_NEW_TRAIL: 'as New Trail',
      NEW_MAP: 'New Map',
      CREATE_MAP: 'Create Map',
      ROUTE: 'Route',
      ROUTES: 'Routes',
      DELETE_ALL: 'Delete All',
      LINKED_TRAIL: 'Linked Trail:',
      RECORDING_LINKED_TO: 'This recording is linked to:',
      MAP_LINKED_TO: 'This map is linked to:',
      TELL_WHAT_YOU_DID: 'Tell people what you did',
      TELL_THE_PLAN: 'Tell people the plan',
      DELETE_WP_QUESTION: 'Delete this waypoint?',
      DELETE_ROUTE_QUESTION: 'Delete this route?',
      ERR_DRAW_ROUTE: 'Error, must draw a route',
      DRAW_ROUTE: 'Draw route',
      FINISH_DRAWING_ROUTE: 'Please finish drawing route (or cancel) before attempting to save.',
      DELETE_ALL_WP_QUESTION: 'Are you sure you want to delete ALL the waypoints for this trail?',
      SHOW_TITLE: 'Show Title',
      SAVE_ENDPOINT: 'Save Endpoint',
      EDIT_ENDPOINT: 'Edit Endpoint',
      ENDPOINT_CONFIRMATION: 'Are you sure you want to save changes to this recording? Please note, once saved, these changes cannot be undone.',
      DIRECTIONS: 'Directions',
      GPX_UPLOAD_TEXT: 'Click or drag a GPX, TCX, FIT or other supported file here',
      PHOTO_UPLOAD_TEXT: 'Click or drag a PNG, JPG, JPEG or PDF photo file here',
      PHOTO_CAPTION_PLACEHOLDER: 'Add a caption',
      RECORDING_TITLE: 'Recording title',
      RECORDING_DESCRIPTION: 'Recording description',
      SHOW_TITLE_ON_MAP: 'Show title on map',
      PHOTO_UPLOAD_ROTATE_LABELS: {
        LEFT: 'Rotate left',
        RIGHT: 'Rotate right'
      },
      VIEW_LIST_FORMATS: {
        __html:
          "View <a href='https://support.alltrails.com/hc/en-us/articles/360032749611-How-do-I-upload-a-file-to-AllTrails-' target='_blank'>supported file formats</a>"
      },
      ENTER_NAME: 'Please enter a name for your recording',
      ENTER_NAME_MAP: 'Please enter a name for your map',
      CANNOT_SAVE_UPDATE: 'Cannot save your update. Please try again.',
      CANNOT_ROUTE: 'Could not route between points. Please try a different activity type, or switch to drawing mode.',
      ERROR_ROUTING: 'An error occurred while attempting to route between points.',
      ERROR_DELETING: 'Error deleting map',
      CONTRIBUTE_PROMPT: 'Share your experience to help other people learn more about this trail:',
      DOWNLOAD_ROUTE: 'Download Route',
      DOWNLOAD_ROUTES: 'Download Routes',
      CHOOSE_FILE_FORMAT: 'Select a file format',
      START_DOWNLOAD: 'Download',
      SAVE_TO_MAPS: 'Save to my maps',
      SHOW_ALL_WPS: 'Show All Titles',
      HIDE_ALL_WPS: 'Hide All Titles',
      REVERSE_ORDER: 'Reverse Order',
      NO_WP_ADDED: 'No waypoints added',
      NO_DESCRIPTION_ADDED: 'No description added',
      UNDO: 'Undo',
      REDO: 'Redo',
      ACTIONS: {
        OUT_AND_BACK: 'Double-back',
        REVERSE: 'Reverse',
        RETURN: 'Close loop'
      },
      TOOLTIPS: {
        OUT_AND_BACK: 'Return back the same way',
        REVERSE: 'Switch your start and end points',
        RETURN: 'Return back the shortest way'
      },
      ROUTING: 'Routing',
      DRAWING: 'Drawing',
      ROUTE_MODES: {
        HIKING: 'Hiking',
        MOUNTAIN_BIKING: 'Mountain Biking',
        BIKE_TOURING: 'Bike Touring',
        ROAD_BIKING: 'Road Biking',
        OFF_ROAD_DRIVING: 'OHV/Off Road Driving',
        SCENIC_DRIVING: 'Scenic Driving'
      },
      ROUTING_TIPS: {
        SMART_TIP: 'Smart Routing:',
        DRAW_TIP: 'Drawing Mode:',
        NODE_TIP: 'Tip:',

        SMART_TIP_TEXT: 'We will route you on the best path for your selected activity',
        DRAW_TIP_TEXT: `Hold 'shift' to free draw`,
        NODE_TIP_TEXT: "Hit the 'delete' / \u232B key to remove a point from your route.",

        TIP_BUTTON_LABEL: 'Close Routing Tips',
        SMART_ROUTING_LABEL: 'Smart Routing'
      }
    },
    REVIEW_UPLOAD_FORM: {
      LINKED_RECORDING: 'Linked Recording',
      PLEASE_ENTER_RATING: 'Please enter a star rating before you submit your review.',
      GIVE_BACK_TO_THE_COMMUNITY: 'Give back to the community. Share your thoughts about the trail so others know what to expect.',
      ANY_CONDITIONS: 'Any conditions to note?',
      POST_REVIEW: 'Post Review',
      NEXT: 'Next',
      POST: 'Post',
      stepText: (currentStep, finalStep) => {
        return `Step ${currentStep} of ${finalStep}`;
      }
    },
    PROFILE: {
      SET_NEW_PASSWORD: 'Set New Password',
      CALORIE_INFO: 'Calorie Counter Info',
      BIRTHDAY: 'Birthday',
      ABOUT_ME: 'About Me',
      UNITS: 'Units',
      RECORDING_PREFERENCE: 'Recording Preference',
      FAVORITE_ACTIVITIES: 'Favorite Activities',
      SPEED: 'Speed',
      PACE: 'Pace',
      LANGUAGE: 'Marketing Language',
      IMPERIAL: 'Imperial',
      METRIC: 'Metric',
      GENDER: 'Gender',
      MALE: 'male',
      FEMALE: 'female',
      HEIGHT: 'Height',
      WEIGHT: 'Weight',
      PRIVACY: 'Privacy',
      UNSPECIFIED: 'unspecified',
      MAKE_PROF_PRIVATE: 'Make my profile private',
      NO_LOCATION: 'No Current Location Info',
      MEMBER_LOCATION: 'Member location:',
      CHANGE_LOCATION: 'Change member location',
      IF_FOR_ORGANIZATION: 'Check here if this profile is for a company/organization',
      CHANGE_IMAGE: 'Change Image',
      ORGANIZATION_NAME: 'Organization Name',
      AUTO_RENEW_PROMPT:
        'Are you sure? Your AllTrails Pro subscription will expire on {date} and will not auto-renew. If you wish to cancel your current subscription, please email support@alltrails.com.'
    },
    STATS: {
      NORMAL: {
        AVG_SPEED: 'Avg Speed',
        AVG_PACE: 'Avg Pace',
        PACE: 'Pace',
        TOTAL_TIME: 'Total Time',
        STATS: 'Stats',
        SPLITS: 'Splits',
        PERSONAL_BESTS: 'Personal Bests',
        DISTANCE: 'Distance',
        TOTAL_DISTANCE: 'Total Distance',
        LONGEST_DISTANCE: 'Longest Distance',
        MOVING_TIME: 'Moving Time',
        ELEVATION_GAIN: 'Elevation Gain',
        ELEV_GAIN: 'Elev Gain',
        COUNT: 'Count',
        CALORIES: 'Calories',
        CALORIES_BURNED: 'Calories Burned',
        LIFETIME_STATS: 'Lifetime Stats',
        ANNUAL_STATS: 'Annual Stats',
        RECORDED_IN: 'Recorded in',
        KILOMETERS: 'Kilometers',
        FEET: 'Feet',
        METERS: 'Meters',
        MILES: 'Miles'
      },
      ABBR: {
        PER_MONTH: '/mo.'
      }
    },
    ELEV_CHART: {
      DISTANCE: 'Distance',
      ELEVATION: 'Elevation',
      GRADE: 'Grade',
      NO_DATA: 'No Elevation Data'
    },
    CONTRIBUTE: {
      WRITE_REVIEW: 'Write review',
      UPLOAD_PHOTOS: 'Upload photos',
      UPLOAD_RECORDINGS: 'Upload recordings',
      UPLOAD_RECORDING: 'Upload recording',
      UPLOAD_ROUTE: 'Upload route',
      ADD_TO_COMPLETED: 'Add to completed',
      REMOVE_FROM_COMPLETED: 'Remove from completed',
      OBSTACLES: 'Obstacles',
      SEASON: 'Season',
      ACCESSIBLE: 'Accessible',
      DOGS: 'Dogs',
      KIDS: 'Kids',
      ACTIVITIES: 'Activities',
      FEATURES: 'Features',
      USAGE: 'Usage',
      TRAILHEAD: 'Trailhead',
      DRAW_ROUTE: 'Draw Route',
      EDIT_ROUTE: 'Edit Route',
      UPLOAD_FILE: 'Upload File',
      BETTER_ROUTE: 'Suggest a better route',
      EDIT_TRAIL_INFO: 'Edit trail information',
      FIND_START_LOC: 'Find the starting location',
      CITY_OR_PARK: 'City or Park',
      SELECT_A_PARK: 'Select a park',
      ADD_TRAIL: 'add trail',
      ENTER_NEW_PARK_NAME: 'Enter new park name',
      DRAW_UPLOAD_RT: 'Draw/Upload the route',
      TRY_AGAIN: 'Try again',
      HERE: 'here',
      ROUTE_INSTRUCTIONS_W_GPX:
        "When adding new trails, we are specifically looking for trails that start and end at a parking area and are on public property. Our strong preference is for out-and-back or loop trails that begin and end in the same location, but of course some trails are through trails and they are welcome too. Please note that any suggested trail additions must first be evaluated by our moderators. This process may take a while depending on our ability to verify the information. To read more about how to draw a route click here.\n  If you have a recorded GPX file for the trail you can 'upload' that instead.",
      ROUTE_INSTRUCTIONS:
        'When adding new trails, we are specifically looking for trails that start and end at a parking area and are on public property. Our strong preference is for out-and-back or loop trails that begin and end in the same location, but of course some trails are through trails and they are welcome too. Please note that any suggested trail additions must first be evaluated by our moderators. This process may take a while depending on our ability to verify the information. To read more about how to draw a route click here.',
      STEPS: ['Step 1', 'Step 2', 'Step 3'],
      NEW: 'New',
      ADD_NEW_PARK: 'Add new park',
      NEW_PARK: 'New Park',
      IN_KILOMETERS: 'in kilometers',
      IN_MILES: 'in miles',
      COMMENT_FROM: 'Comment from {userFirstName}',
      DRAG_PHOTOS_HERE: {
        __html: 'Drag photos here or <span>browse</span>'
      },
      DRAG_RECORDING_HERE: {
        __html: 'Drag recording here or <span>browse</span>'
      },
      DRAG_ROUTE_HERE: {
        __html: 'Drag route here or <span>browse</span>'
      },
      PNG_JPG_JPEG_PDF: 'PNG, JPG, JPEG or PDF',
      PNG_JPG_JPEG: 'PNG, JPG or JPEG',
      GPX_TPO_FIT_TCX: 'GPX, TPO, FIT, or TCX',
      RETURN_TO_TRAIL: 'Return to trail',
      THANKS_FOR_CONTRIBUTING: 'Thanks for contributing!',
      YOUR_CHANGES: "Your Changes will be reviewed and the trail updated as soon as they're approved.",
      CONTRIBUTE_HELP: 'Contribute Help',
      DO_YOU_KNOW_THE_ROUTE: 'Do you know the route for this trail?',
      PLEASE_DRAW_CORRECT_ROUTE: 'Please draw the correct route.',
      IS_ROUTE_CORRECT: 'Is the route of this trail correct?',
      LAST_EDITED: 'Last edited'
    },
    LIFELINE: {
      TRACK_PROGRESS: 'Track Progress',
      VIEW_ROUTE: 'View Planned Route',
      LIVE_UPDATES: 'See Live Updates',
      SEE_COMPLETED: 'See Completed Activity',
      COMPLETED_DATA: 'Completed Activity Details',
      PLANNED_DETAILS: 'Planned Activity Details',
      KEEP_ADVENTURERS_SAFE: 'Keeping adventurers safe on the trail',
      SMS_RATES: 'Standard SMS rates will apply to messages you receive.  Live tracking can only update when the user’s phone has a data signal.',
      MORE_INFO: 'More Info',
      NOT_STARTED_YET: 'Not Started Yet or No Data Signal',
      FINISHED_AND_SAFE: 'Finished & Reported Safe',
      ACTIVITY_IN_PROGRESS: 'Activity In Progress',
      DIRECTIONS_TRAILHEAD: 'Directions to Trailhead',
      LAST_RECORDED: 'LAST RECORDED TIME',
      LAST_RECORDED_LOC: 'LAST RECORDED LOCATION',
      ACTUAL_START: 'ACTUAL START TIME',
      PLANNED_START: 'PLANNED START TIME',
      PLANNED_END: 'PLANNED END TIME',
      ACTUAL_DISTANCE: 'ACTUAL DISTANCE',
      PLANNED_DISTANCE: 'PLANNED DISTANCE',
      ACTUAL_ELEV: 'ACTUAL ELEVATION GAIN',
      PLANNED_ELEV: 'PLANNED ELEVATION GAIN',
      REPORTED_SAFE: 'Reported as Safe',
      NOT_STARTED: 'Not Started',
      NO_DATA_RECEIVED: 'No Data Received',
      GET_DETAILS: 'Get the details before they hit the trail. See planned start and end times for their upcoming adventure.',
      STAY_INFORMED: 'Stay informed and track progress. Follow where they are on an easy-to-read map.',
      SEE_STATS: 'See stats like total distance and elevation gain to track their accomplishments.',
      STAY_IN_CONTACT: "Stay in contact. We’ll notify you once they're back safely or if they're running late.",
      OVERDUE: 'Overdue',
      SCHEDULED_END: 'Scheduled end time:',
      SCHEDULED_START: 'Scheduled start time:',
      SHARED_MSG:
        "Has shared a Lifeline with you.  You can follow {userFirstName}'s real-time location during the activity.  If you or {userFirstName} encounter limited GPS or data coverage, Lifeline information could be delayed.",
      LATE_START:
        '{userFirstName} planned to start this activity by now, but either doesn’t have a data connection, or isn’t recording in the AllTrails app yet.  Please check back in a bit.',
      DO_NOT_PANIC: 'Do not panic',
      EMERGENCY: 'Emergency Services',
      REASSURANCE_MSG:
        "It is likely {userFirstName} is alright. {userFirstName}'s phone may have lost connection, battery power, or {userFirstName} is running behind and still enjoying the trail.",
      PROVIDE_INFO:
        'If you have reason to believe {userFirstName} is in danger, contact local authorities associated with the trail.  Please provide the trail information below to local emergency services.'
    },
    OVERLAYS: {
      WEATHER: 'Weather',
      AIR_QUALITY: 'Air quality',
      POLLEN: 'Pollen',
      LIGHT: 'Light pollution',
      FIRE_HISTORY: 'Fire history',
      NEARBY_TRAILS: 'Nearby trails',
      HEATMAP: 'Heatmap',
      PHOTOS: 'Photos',
      WAYPOINTS: 'Waypoints',
      US_CONTOURS: 'US contours',
      WAYMARKED_HIKING: 'Waymarked hiking',
      WAYMARKED_CYCLING: 'Waymarked cycling',
      WAYMARKED_MTB: 'Waymarked MTB',
      DISTANCE_MARKERS: 'Distance markers'
    },
    PROGRESS_MESSAGES: {
      PROCESSING: 'Processing',
      MAP_BEING_SAVED: 'Your map is being saved...',
      MAP_BEING_LOADED: 'Your map is being loaded...',
      SAVED: 'Saved',
      LOADED: 'Loaded',
      ERROR_SAVING: 'Error saving, please try again.'
    },
    FILTERS: {
      MORE_FILTERS: 'More filters',
      TRAIL_LINKED: 'Linked to trail',
      TRAIL_UNLINKED: 'Not linked to trail',
      TRAIL_COMPLETION: 'Trail completion',
      DIFFICULTY: 'Difficulty',
      ACTIVITY: 'What to do',
      ACTIVITY_LABEL: 'Activity',
      FEATURES: 'What to see',
      FEATURES_LABEL: 'Attractions',
      SUITABILITY: 'Suitability',
      PARK: 'Park',
      CITY: 'City',
      STATE: 'State',
      COUNTRY: 'Country',
      ELEV_GAIN: 'Elevation gain',
      LENGTH: 'Length',
      TIME: 'Time',
      EST: 'Est.',
      ROUTE_TYPE: 'Route type',
      TRAIL_TRAFFIC: 'Trail traffic',
      RATING: 'Rating',
      SORT: 'Sort by',
      SORT_LABEL: 'Sort',
      AND_UP: '& up',
      ACTIVITIES: {
        BACKPACKING: 'Backpacking',
        BIKE_TOURING: 'Bike touring',
        BIRDING: 'Bird watching',
        CAMPING: 'Camping',
        CROSS_COUNTRY_SKIING: 'Cross-country skiing',
        FISHING: 'Fishing',
        HIKING: 'Hiking',
        HORSEBACK_RIDING: 'Horseback riding',
        MOUNTAIN_BIKING: 'Mountain biking',
        NATURE_TRIPS: 'Nature trips',
        OFF_ROAD_DRIVING: 'OHV/Off-road driving',
        PADDLE_SPORTS: 'Paddle sports',
        ROAD_BIKING: 'Road biking',
        ROCK_CLIMBING: 'Rock climbing',
        SCENIC_DRIVING: 'Scenic driving',
        SKIING: 'Skiing',
        SNOWSHOEING: 'Snowshoeing',
        SURFING: 'Surfing',
        TRAIL_RUNNING: 'Trail running',
        VIA_FERRATA: 'Via ferrata',
        WALKING: 'Walking',
        BIRD_WATCHING: 'Bird watching'
      },
      FEATURE_TYPES: {
        BEACH: 'Beach',
        CAVE: 'Cave',
        CITY_WALK: 'City walk',
        EVENT: 'Event',
        FOREST: 'Forest',
        HISTORIC_SITE: 'Historic site',
        HOT_SPRINGS: 'Hot springs',
        LAKE: 'Lake',
        PUB_CRAWL: 'Pub walk',
        RAILS_TRAILS: 'Rails trails',
        RIVER: 'River',
        VIEWS: 'Views',
        WATERFALL: 'Waterfall',
        WILD_FLOWERS: 'Wildflowers',
        WILDLIFE: 'Wildlife'
      },
      OBSTACLES: {
        BLOWDOWN: 'Blowdown',
        BRIDGE_OUT: 'Bridge out',
        BUGS: 'Bugs',
        CLOSED: 'Closed',
        FEE: 'Fee',
        FLOODED: 'Flooded',
        GREAT: 'Great!',
        ICY: 'Icy',
        MUDDY: 'Muddy',
        NO_SHADE: 'No shade',
        OFF_TRAIL: 'Off trail',
        OVER_GROWN: 'Over grown',
        PRIVATE_PROPERTY: 'Private property',
        ROCKY: 'Rocky',
        SCRAMBLE: 'Scramble',
        SNOW: 'Snow',
        WASHED_OUT: 'Washed out'
      },
      ACCESS: {
        ADA: 'Wheelchair friendly',
        DOGS: 'Dog friendly',
        DOGS_ON_LEASH: 'Dogs on leash',
        KID_FRIENDLY: 'Kid friendly',
        NO_DOGS: 'No dogs',
        PARTIALLY_PAVED: 'Partially paved',
        PAVED: 'Paved',
        STROLLER_FRIENDLY: 'Stroller friendly',
        WHEELCHAIR_FRIENDLY: 'Wheelchair friendly'
      },
      ROUTE_TYPES: {
        LOOP: 'Loop',
        OUT_AND_BACK: 'Out & back',
        POINT_TO_POINT: 'Point to point'
      },
      USAGES: {
        LIGHT: 'Light',
        MODERATE: 'Moderate',
        HEAVY: 'Heavy',
        EXTRA_HEAVY: 'Extra heavy'
      },
      SORT_TYPES: {
        BEST_MATCH: 'Best match',
        MOST_POPULAR: 'Most popular',
        CLOSEST: 'Closest',
        LIST_ORDER: 'List order',
        DATE: 'Date',
        NAME: 'Name'
      },
      COMPLETED: 'Completed',
      UNCOMPLETED: 'Uncompleted',
      VERIFIED: 'Verified completed',
      UNVERIFIED: 'Completed'
    },
    MOBILE: {
      TEXT_LINK: 'Text link',
      EMAIL_LINK: 'Email link',
      SENT: 'Sent',
      SENDING: 'Sending',
      ERROR_SEND_TEXT: 'There was a problem sending the text.  Please check the number and try again.',
      SEND_TO_PHONE_EXPLAIN: 'Send a link to your phone so you can get driving directions and see detailed trail maps on the go.'
    },
    BEST_LOCATIONS: {
      TOP_PARKS: 'Top parks',
      TOP_REGIONS: 'Top regions',
      TOP_STATES: 'Top states',
      TOP_CITIES: 'Top cities',
      TOP_NATIONAL_PARKS: 'Top national parks',
      TOP_STATE_PARKS: 'Top state parks',
      TOP_LOCAL_PARKS: 'Top local parks'
    },
    DIFFICULTY: {
      CAPS: {
        DEFAULT: 'DIFFICULTY',
        EASY: 'EASY',
        MODERATE: 'MODERATE',
        HARD: 'HARD'
      },
      LOWER: {
        DEFAULT: 'difficulty',
        EASY: 'easy',
        MODERATE: 'moderate',
        HARD: 'hard'
      },
      NORMAL: {
        EASY: 'Easy',
        MODERATE: 'Moderate',
        HARD: 'Hard',
        DIFFICULT: 'Difficult',
        STRENUOUS: 'Strenuous'
      }
    },
    COUPON: {
      FREE: 'free',
      PLACEHOLDER: 'Coupon code',
      MY_COUPON_CODES: 'My Coupon Codes',
      NOT_VALID: 'Coupon not valid',
      THE_NOT_VALID: 'The coupon code you entered is not valid',
      NO_LONGER_VALID: 'This coupon is no longer valid',
      PREV_REDEEMED: 'Coupon previously redeemed',
      NOT_THIS_ACCOUNT: "Can't be used on this account",
      FREE_YEAR_VALID: 'Coupon valid for one free year of AllTrails Pro! Your card will not be charged for the first year of your subscription.',
      I_HAVE_CODE: 'I have a coupon code',
      WAIT: 'wait',
      REDEEMED: 'Redeemed',
      NOT_REDEEMED: 'Not Redeemed',
      REMOVE: 'remove',
      APPLY: 'apply',
      LINK_TO_PDF: 'Link to PDF',
      BUY_GIFT: 'Buy Gift',
      VIEW_PDF: 'View PDF',
      BUY_AGAIN: 'Buy Again',
      ERROR_PROCESSING: 'There was an error processing your credit card.',
      GIFT_INSTRUCTIONS: "To purchase a gift subscription, simply click the 'Buy Gift' button below:",
      CARD_CHARGE_NORMAL: 'Your card on file will be charged {fullPrice}.',
      CARD_CHARGE_DISCOUNT: 'Your card on file will be charged {giftPrice}, which is discounted from the standard one year rate of {fullPrice}.',
      GIFT_POST_BUY: "A link to a PDF with a unique coupon code and instructions to redeem it will appear in 'My Coupon Codes' area below.",
      GIFT_SHARE: "Email the PDF file as an e-gift, or print it out. Either way it's sure to be a hit!"
    },
    SIGNUP: {
      FB_EMAIL_ACCESS_NOTICE: 'Permission to access email address via FB has not been properly granted.',
      FB_EMAIL_AUTH_MISSING_NOTICE:
        'AllTrails requires your email address to create an account - please try signing up with Facebook again and make sure to grant access to your email address.',
      AT_LEAST_SIX_CHARS: 'Must be at least 6 characters',
      MUST_BE_VALID_EMAIL: 'Must be a valid email',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      LOGIN: 'Log in',
      PLEASE_WAIT: 'Please Wait',
      CONTINUE_WITH_GOOGLE: 'Continue with Google',
      CONTINUE_WITH_FB: 'Continue with Facebook',
      CONTINUE_WITH_APPLE: 'Continue with Apple',
      CONNECT_WITH_GOOGLE: 'Connect with Google',
      CONNECT_WITH_APPLE: 'Connect with Apple',
      CONNECTED: 'Connected',
      UNLINK: 'unlink',
      FORGOT_PASSWORD: 'Forgot Password?',
      SIGNUP: 'Sign up',
      EMAIL_SUBSCRIBE: 'Product News, tips and special offers'
    },
    PRO: {
      ALLTRAILS_PRO: 'AllTrails Pro',
      ACTIVE_ADVANTAGE_DISCLAIM:
        'As of January 7th, 2017, Active Advantage subscribers will no longer qualify for free AllTrails Pro. Renew your subscription today to maintain your Pro status and get 50% off.',
      NORMAL_RENEWAL_DISCLAIM: 'Note: You will be charged {discountPrice} today and renewed next year unless you update your renewal settings.',
      DISCOUNT_RENEWAL_DISCLAIM:
        'Note: You will be renewed at the regular price of {regularPrice} next year unless you update your renewal settings.',
      FREE_DISCLAIM:
        'Note: This gift card is good for 1 year of AllTrails Pro. This offer cannot be combined with other discounts or applied after an order has been placed. One redemption per person. Offer not valid on previous subscriptions to AllTrails Pro. Offer cannot be redeemed for cash. Terms of offer are subject to change.',
      REDEEM: 'Redeem',
      PURCHASE: 'Purchase',
      PURCHASE_ANNUAL: 'Purchase Annual',
      FOR_FIRST_YEAR: 'for the first year',
      LIFETIME: 'Lifetime',
      ANNUAL: 'Annual',
      BILLED_ONCE: 'one fee',
      BILLED_ANNUALLY: 'yearly fee',
      CVV_ERROR: 'Please check the 3 or 4 digit security code on your card',
      CC_NUM_ERROR: 'Please check your credit card number',
      MONTH: 'Month',
      YEAR: 'Year',
      THREE_YEAR: '3 Year',
      FIVE_YEAR: '5 Year',
      CARD_NUMBER: 'Card number',
      ZIPCODE: 'Zipcode',
      CVV: 'CVV',
      REGULAR_PRICE: 'Regular Price'
    },
    PRO_DISCOUNT_POPUP: {
      PCT_OFF: '20% OFF',
      LAST_CHANCE: 'This is your chance - take this one-time offer to get 20% off your first year of AllTrails Pro',
      LEARN_MORE: 'Learn More',
      NO_THANKS: 'NO THANKS'
    },
    WAYPOINT_POPUP: {
      SHOW_TITLE: 'Show title',
      HIDE_TITLE: 'Hide title',
      REMOVE_FROM_MAP: 'Remove from map'
    },
    CONVERTER: {
      FILE_TYPES: {
        ROUTE: 'Track / Route',
        WAYPOINTS: 'Waypoints'
      },
      ERROR_MESSAGES: {
        NO_FILE_ATTACHED: 'Please attach a file or file url to convert.',
        TOO_LARGE: 'Your file is too large, Please choose a file below 8mb.',
        UPLOAD_FAILED: 'There was an issue uploading your file. Please check your file and try again.'
      },
      ROUTE_OPTION_STRINGS: {
        REVERSE_ROUTE: 'Reverse route',
        OUT_AND_BACK: 'Change to Out & Back route',
        ADD_ELEVATION: 'Add / Replace elevation',
        COMBINE_ROUTES: 'Combine multiple routes into one route'
      },
      ROUTE_SIMPLIFICATION_STRINGS: {
        NONE: 'None',
        LOW: 'Low (Reduce by 25%)',
        MEDIUM: 'Medium (Reduce by 50%)',
        HIGH: 'High (Reduce by 75%)',
        CUSTOM: 'Customize:'
      },
      ON: 'On',
      OFF: 'Off',
      OR: 'or',
      HERO_TITLE: 'Route Converter',
      UPLOAD_FILE: 'Upload File',
      UPLOAD_FILE_PROMPT: 'Use the AllTrails Route Converter to upload a route and convert to any of our supported file formats.',
      VIEW: 'View',
      SUPPORTED_FILE_FORMATS: 'Supported File Formats',
      DRAG_PROMPT: 'Drag supported file here',
      DRAG_PROMPT_LINK: 'Or choose file to upload',
      FILE_URL_PLACEHOLDER: 'Link to supported file here',
      CONVERT_TO: 'Convert to',
      DOWNLOAD_AS: 'Download as:',
      CUSTOMIZE_ROUTE: 'Customize Route',
      ROUTE_OPTIONS: 'Route Options',
      ROUTE_SIMPLIFICATION: 'Route Simplification',
      CUE_SHEETS: 'Cue Sheets',
      CUE_SHEETS_PROMPT: 'Cue sheets can be used with third party vendors. You can customize cues to meet the specifications of your watch or device',
      NUMBER_OF_CUES: 'Number of cues:',
      MOVE_CUE_LEAD: 'Move cue:',
      MOVE_CUE_TAIL: 'before turn',
      CONVERT_BUTTON: 'Convert file',
      SUBMITTING_TEXT: 'Please wait',
      DRAG_SUPPORTED: 'Drag supported file here',
      OR_CHOOSE_FILE: 'Or choose file to upload',
      FILE_SIZE: 'File Size',
      REMOVE_FILE: 'Remove file',
      SUPPORTED_FORMATS_LEAD: 'The following formats are supported (maximum 8MB, automatically detected):',
      SUPPORTED_FORMATS_LIST:
        'Google Earth (KML, KMZ), Google Maps directions (XML, JSON), PCX5 (tracks, waypoints), GPX (tracks, routes, waypoints), GPX Garmin Streetpilot, Garmin Course (CRS, TCX), FIT (ANT+), MS Excel, CSV (Comma-Separated-Values), Falk IBEX Tour, CompeGPS, VDO GP7 (TRC), GeoRSS, Logbook, NMEA, OVL (ASCII), Fugawi, KOMPASS Verlag (Alpenverein), TrainingPeaks (PWX), Navigon Route, OziExplorer, qpeGps Track, MagicMaps IKT, TomTom BIN (ttbin), TomTom ITN, Suunto SDF, Magellan Track, PathAway',
      CONVERT_FILE: 'Convert file',
      CONVERTER_SUCCESS: {
        TITLE: 'All finished!',
        SUBMITTING_TEXT: 'Please wait',
        PROMPT_LEAD: 'Your new file was added to your “downloads” folder. If you do not see the file, click',
        HERE: 'here',
        PROMPT_TAIL: 'to retry your download. Have fun out on the trail!',
        CONVERT_ANOTHER_FILE: 'Convert another file',
        SUBTITLE_SAVE: 'Save this route to your account and never lose the file',
        BUTTON_SAVE: 'Save to',
        RECORDINGS: 'Recordings',
        MAPS: 'Maps',
        SUBTITLE_CREATE_MAP: 'Create custom maps to personalize your trip',
        BUTTON_CREATE_MAP: 'Create New Map'
      }
    },
    NAVIGATION: {
      LOGO_ALT_TEXT: 'AllTrails',
      PRO_BADGE_ALT_TEXT: 'Learn more about pro subscription',
      LOGIN: 'Log In',
      SIGNUP: 'Sign Up',
      LOGOUT: 'Logout',
      SETTINGS: 'Settings',
      MEMBERS: 'Members',
      PHOTOS: 'Photos',
      REVIEWS: 'Reviews',
      PROFILE: 'Profile',
      UPGRADE_TO_PRO: 'Upgrade to Pro',
      EXPLORE: 'Explore',
      PLAN: 'Plan',
      FAVORITES: 'Favorites',
      LISTS: 'Lists',
      MAPS: 'Maps',
      CREATE_MAP: 'Create Map',
      HISTORY: 'History',
      RECORDINGS: 'Recordings',
      COMPLETED: 'Completed',
      STATS: 'Stats',
      HELP: 'Help',
      DOWNLOAD_THE_APP: 'Download the app'
    },
    SHARE_MODAL: {
      COPY_NOT_AVAILABLE: 'Copy Link is not available in your web browser',
      ON_ALLTRAILS: 'on AllTrails',
      CHECK_THIS_OUT_ON_ALLTRAILS: 'Check this out on AllTrails',
      DOWNLOAD_THE_FREE_ALLTRAILS_APP: 'Download the free AllTrails App.',
      EMBED_THIS: 'Embed this',
      TEXT_THIS: 'Text this',
      COPY_LINK: 'Copy Link',
      LINK_COPIED: 'Link Copied',
      SEND_TEXT: 'Text',
      TEXT_SENT: 'Text Sent',
      SEND_EMAIL: 'Email',
      EMBED_WIDGET: 'Embed',
      QR_CODE: 'QR Code',
      TO_ADD_THIS_TRAIL_TO_YOUR_WEBSITE: 'To add this trail to your website, copy and paste the following HTML into your website code:',
      CUSTOMIZE_YOUR_CODE: 'Customize your code',
      COPY_HTML: 'Copy HTML',
      HTML_COPIED: 'HTML Copied',
      DEACTIVATE_MOUSE_ZOOM: 'Deactivate zoom with mouse',
      HIDE_ELEVATION_GRAPH: 'Hide elevation graph',
      HIDE_YOUR_NAME: 'Hide your name',
      PREVIEW: 'Preview',
      DOWNLOAD_QR_CODE: 'Download QR Code',
      DOWNLOAD_INSTRUCTIONS:
        'Download this QR Code to quickly link others to the important information on this page. QR codes can be read by any device with the appropriate software. Use the smart phone or tablet to read the QR code.',
      SMS_INSTRUCTIONS:
        'Text this trail to your friends, family or yourself so you can get driving directions and see detailed trail maps on the go.',
      PRIVATE_WARNING: 'This content is private and only you will be able to view it.',
      TYPE_TITLE: {
        TRAIL: 'trail',
        MAP: 'map',
        TRACK: 'recording',
        LIST: 'list',
        AREA: 'park',
        STATE: 'state',
        COUNTRY: 'country',
        CITY: 'city'
      }
    },
    LIST_MODAL: {
      SAVE_TO_LIST: 'Save to List',
      CREATE_NEW_LIST: 'Create New List',
      CREATE_A_LIST: 'Create a list',
      MY_FAVORITES: 'My Favorites',
      NAME_YOUR_LIST: 'Name your list',
      ERROR_CREATE_LIST: 'There was an error creating your list',
      TYPE_SINGLE: {
        TRAIL: 'Trail',
        MAP: 'Map',
        TRACK: 'Recording'
      },
      TYPE_MULTIPLE: {
        TRAIL: 'Trails',
        MAP: 'Maps',
        TRACK: 'Recordings'
      }
    },
    BRANCH: {
      ROADBLOCK: {
        TITLE: 'AllTrails - Your guide to the outdoors',
        DESCRIPTION: 'AllTrails works best if you switch to our mobile-friendly app',
        GET_HAS_APP: 'Continue in App',
        GET_NO_APP: 'Continue in App'
      }
    },
    MAP_CREATOR: {
      MAP_CREATOR: 'Map creator',
      CREATE_NEXT_ROUTE: 'Create your next route or edit saved maps',
      CUSTOM_ROUTE: 'Custom Route',
      SEARCH_FOR_LOCATION: 'Search for a location or click anywhere on the map to draw',
      TITLE_LABEL: 'Name your map',
      DESCRIPTION: 'Description',
      DESCRIPTION_LABEL: 'Add notes about your route',
      ACTIVITY: 'Activity',
      PRIVATE_LABEL: 'Toggle map privacy settings',
      PRIVATE: 'Make map private',
      WAYPOINTS: 'Waypoints',
      PHOTOS: 'Photos',
      ADD_NEW_PHOTOS: 'Add new photos',
      SAVE_MAP: 'Save map',
      EDIT_MAP: 'Edit map',
      DOWNLOAD_MAP: 'Download Map',
      REFRESH: 'Refresh',
      REFRESHED: 'Refreshed',
      ADD_AS_NEW_MAP: 'Add as new map',
      ADD_AS_NEW_TRAIL: 'Add as new trail',
      SUGGEST_AS_NEW_TRAIL: 'Suggest as new trail',
      SUGGEST_AS_NEW_MAP: 'Suggest as new map',
      LINKED_TRAIL: 'Linked trail',
      NEW_MAP_CREATED: 'New map created',
      SAVING_YOUR_MAP: 'Saving your map',
      ERROR_SAVING: 'Error saving',
      MAP_SAVED: 'Map saved',
      CLICK_TO_ADD_POINT: 'Click to add point',
      DELETE_MAP: 'Delete map',
      SEARCH_OR_CLICK_ON_MAP_TO_START: 'Search or click on the map to start',
      DRAG_TO_CHANGE_DELETE_TO_REMOVE: "Drag to change route, 'delete' to remove",
      WAYPOINT_ERROR: 'There has been an error, please try again',
      START_HERE: 'Start here',
      ADD_TO_ROUTE: 'Add to route',
      CLOSE_POPUP: 'Close popup',
      ROUTE_WITH_NUMBER: number => {
        return `Route ${number}`;
      },
      NEED_HELP: 'Need help?'
    },
    REDEMPTION_PAGE: {
      REDEEM: 'Redeem',
      REDEEM_YOUR_CARD: {
        __html: 'Redeem your <span>gift card.</span>'
      },
      REDEMPTION_CODE: 'Redemption Code',
      ONCE_YOU_REDEEM: `Once you redeem the gift card, your account will be updated and you can start enjoying the benefits 
        of Pro. Your subscription begins on the redemption date and will be active for the length of the plan that was purchased.`,
      MOBILE_GIFT: {
        __html: `Your account has a current mobile subscription. Please read our <a href="https://support.alltrails.com/hc/en/articles/360052407531-I-already-have-a-Pro-subscription-through-iTunes-or-Google-Play-how-can-I-redeem-the-gift-I-received-" target="_blank">FAQ</a> to learn how to redeem your gift.`
      }
    },
    GIFT_FLOW: {
      GIVE_THE_GIFT: 'Give the gift of adventure',
      FEATURES_DESIGNED_FOR_ALL: 'Features designed for all',
      PICK_YOUR_GIFT: 'Pick your gift',
      BUY_GIFT: 'Buy gift',
      AN_EASY_WAY: 'An easy way to give joy',
      SEND_THE_GIFT_OF_EXPLORATION: 'Send the gift of exploration to your friends and family with an AllTrails Pro gift card.',
      QUICK_AND_EASY: 'Quick and easy',
      PURCHASE_EASILY: 'Purchase a gift card easily. It arrives in moments and we notify you of delivery.',
      CUSTOMIZABLE: 'Customizable',
      CHOOSE_LENGTH_OF_PLAN: 'Choose the length of plan, a design you love and personalize a message.',
      SEND_VIA_EMAIL_PRINT: 'Send via email or print',
      CHOOSE_DELIVERY_DATE: 'Choose the delivery date the gift card will be emailed. Or, print and hand-deliver.',
      PERFECT_FOR_ALL_OCCASIONS: 'Perfect for all occasions and outdoor enthusiasts.',
      CELEBRATE_THE_PEOPLE:
        'Celebrate the people you appreciate on birthdays, holidays, graduations and more. With the ability to browse by activity, it’s a fitting gift for any type of outdoor explorer in your life.',
      GIVE_A_GIFT_CARD: 'Give an AllTrails Pro gift card',
      HELP_GET_ADVENTURE_STARTED: 'Help them get the adventure started.',
      PROUD_ONE_PERCENTER:
        'As a proud member of 1% for the Planet, we give 1% of our annual sales to nonprofit organizations focusing on protecting the wild places we cherish and creating positive change for a healthier planet.',
      CHOOSE_A_CHECKOUT_METHOD: 'Choose a checkout method',
      CHECKOUT_AS_GUEST: 'Checkout as guest',
      ALLTRAILS_2020: '2020 AllTrails, Inc. All Rights Reserved',
      ALT_TEXT: {
        CARDS_IMAGE: 'AllTrails gift cards',
        FRIENDS_AT_THE_SUMMIT: 'Friends relaxing at a rocky summit',
        TWO_CYCLISTS: 'Two cyclists walking their bikes across a wooden bridge',
        PERSON_TRAIL_RUNNING: 'Person trail running on a beautiful sunny day',
        PERSON_CYCLING: 'Person cycling up a long and windy hill'
      },
      GIFT_REVIEW: {
        GIFT_CARD_PURCHASED: 'Gift card purchased.',
        THANK_YOU: 'Thank you!',
        PLAN: 'Plan',
        THANKS_FOR_GIVING:
          'Thank you for giving the gift of AllTrails Pro. We are in the process of delivering the gift card to the recipient. We will inform you when it has been sent.',
        CHECK_FOR_CONFIRMATION: 'Check your inbox for a confirmation email.',
        DOWNLOAD_GIFT_CARD: 'Download gift card',
        BUY_AGAIN: 'Buy again',
        START_EXPLORING: 'Start exploring!',
        CHECK_CONFIRMATION_AND_DOWNLOAD: 'Check your inbox for a confirmation email. Download the gift card below.'
      },
      FAQ: {
        HOW_DO_I_REDEEM: 'How do I redeem my card?',
        HOW_DO_I_REDEEM_ANSWER:
          'AllTrails gift cards are delivered by email. They contain a redemption code and link to redeem on the web. When redeemed, the Pro subscription will be applied to your account.',
        CAN_I_GIVE_A_SUBSCRIPTION: 'Can I give a subscription to someone who already has a Pro account?',
        CAN_I_GIVE_A_SUBSCRIPTION_ANSWER: {
          __html:
            "Yes, the time value of the AllTrails gift subscription will be applied to their existing subscription. Once they’ve redeemed the gift membership on their account, they won't be charged for their regular subscription until your gift expires. <strong>If your recipient has an active AllTrails subscription through iTunes or Google Play</strong>, they’ll need to cancel their subscription and allow it to expire, prior to redeeming the gift. Due to restrictions on adjusting this payment method, we are unable to modify subscriptions purchased via app stores directly, which includes automatically adding gift membership time to an existing subscription."
        },
        WILL_I_KNOW: 'Will I know if my recipient receives their gift?',
        WILL_I_KNOW_ANSWER:
          'Yes. You will receive an email notification when the gift email is opened. If your recipient does not redeem their gift right away, AllTrails will send up to 1 redemption reminder emails.',
        WAS_NOT_RECIEVED: 'The card I sent wasn’t received?',
        WAS_NOT_RECIEVED_ANSWER: {
          __html:
            "If your gift recipient missed an email, send the order confirmation number to <a href='mailto:support@alltrails.com'>support@alltrails.com</a> and we'll investigate. "
        },
        IS_THERE_AN_EXPIRATION: 'Is there an expiration date on the card?',
        IS_THERE_AN_EXPIRATION_ANSWER:
          'There is no expiration date on the redemption code for the gift card. Once redeemed, the code is good for the length of the subscription that was gifted.',
        CAN_I_BUY_A_PHYSICAL_GIFT_CARD: 'Can I buy a physical gift card?',
        CAN_I_BUY_A_PHYSICAL_GIFT_CARD_ANSWER:
          'At this time, gift cards are only available via email. You can also print a pdf of the card to physically deliver to the recipient yourself.',
        FREQUENTLY_ASKED_QUESTIONS: 'Frequently asked questions'
      },
      GIFT_CUSTOMIZE_FORM: {
        EMAIL: 'Email',
        PRINT: 'Print',
        ENTER_AN_EMAIL: 'Enter an email',
        ENTER_A_NAME: 'Enter a name',
        ENTER_VALID_EMAIL: 'Enter a valid email',
        CUSTOMIZE_YOUR_GIFT: 'Customize your gift',
        HOW_DO_YOU_WANT_TO_SEND: 'How do you want to send it?',
        TO: 'To',
        FROM: 'From',
        NAME: 'Name',
        MESSAGE: 'Message',
        SEND_DATE: 'Send date',
        NEXT: 'Next',
        FIVE_HUNDRED_CHARACTERS_MAX: '500 character maximum'
      },
      SHOPIFY: {
        SHOP_ALL: 'Shop all',
        GEAR_UP: 'Gear up for the adventure'
      },
      PRINT: {
        NEW_TO_ALLTRAILS: 'New to AllTrails?',
        CREATE_ACCOUNT: linkComponent => {
          return `Go to ${linkComponent} to create an account`;
        },
        ALREADY_HAVE_ONE: 'Already have an AllTrails account?',
        REDEEM_GIFT: linkComponent => {
          return `Use your redemption code at ${linkComponent}`;
        },
        REDEMPTION_CODE: 'Redemption code',
        YOUR_GIFT_CARD: 'Your gift card',
        ANNUAL_PRO_PLAN: 'Annual Pro Plan',
        THREE_YEAR_PRO_PLAN: 'Three-Year Pro Plan'
      },
      PAYMENT_FORM: {
        GIFT_PAYMENT_HEAD_TEXT: 'Enter payment details',
        SUBMIT_TEXT: 'Give AllTrails Pro'
      },
      NEED_HELP_ASK_SUPPORT: (mailTo, helpCenter) => {
        return `Need help? Ask at ${mailTo} or visit our ${helpCenter}`;
      },
      HELP_CENTER: 'Help Center',
      ATHLETES: {
        HIKERS: 'Hikers',
        MOUNTAIN_BIKERS: 'Mountain bikers',
        TRAIL_RUNNERS: 'Trail runners',
        BACKPACKERS: 'Backpackers',
        ROAD_BIKERS: 'Road bikers',
        ROCK_CLIMBERS: 'Rock climbers',
        SNOWSHOERS: 'Snowshoers',
        SKIERS: 'Skiers'
      },
      AND_MORE: 'and more'
    },
    END_TRANSLATE: 'END_TRANSLATE'
  },
  constants: {
    SUPPORTED_LANGUAGES: [
      { iso_3166_code: 'EN', locale_code: 'en-US', sort_name: 'A', country: 'United States', language_drop_down_name: 'English' },
      { iso_3166_code: 'FR', locale_code: 'fr-FR', sort_name: 'AAA', country: 'France', language_drop_down_name: 'Français' },
      { iso_3166_code: 'DE', locale_code: 'de-DE', sort_name: 'AAAA', country: 'Germany', language_drop_down_name: 'Deutsch' },
      { iso_3166_code: 'ES', locale_code: 'es-ES', sort_name: 'AAAAA', country: 'Spain', language_drop_down_name: 'Español' }
    ],
    XLATE: {
      GOOGLE: 'xlate-google',
      SMARTLING: 'xlate-smartling',
      NONE: 'xlate-none'
    },
    ALGOLIA: {
      ACCOUNT: '9IOACG5NHE',
      API_KEY: '63a3cf94e0042b9c67abf0892fc1d223',
      INDEX: 'alltrails_index3',
      PENDING_INDEX: 'pending_trails_prod'
    },
    APPLE_SIWA: {
      AUTHORIZE_URL: 'https://appleid.apple.com/auth/authorize',
      AUTHORIZE_PARAMS: '?response_type=code%20id_token&response_mode=form_post',
      CLIENT_ID: 'com.alltrails.AllTrails.web',
      SCOPES: 'name email',
      REDIRECT_PATH: '/users/auth/apple/callback'
    },
    GOOGLE_RECAPTCHA: {
      SITE_KEY: '6Le5UOUUAAAAAGxhyG6f5iEA2qf75SAa1BivOtZm'
    },
    MAGIC: {
      ANONYMOUS_MAP_USERNAME: 'alltrails-guest-maps'
    },
    // Limits are in MB
    FILE_UPLOAD_SIZE_LIMIT: {
      ROUTE: 8,
      PHOTO: 8
    }
  },
  // returns value or original string if not found in supplied dictionary
  stringsLookup(dict, str) {
    if (!str) {
      console.error('Provided null `str` value lookup');
      return '';
    }
    const key = str.toUpperCase().replace(/ /g, '_');
    return dict[key] || str;
  }
};

const replaceStrings = (string, replaceMap) => {
  let newString = string;
  if (replaceMap instanceof Array) {
    for (let i = 0; i < replaceMap.length; i++) {
      const stringKey = `{${replaceMap[i].stringKey}}`;
      newString = newString.replace(stringKey, replaceMap[i].stringValue);
    }
  } else {
    newString = newString.replace(replaceMap.stringKey, replaceMap.stringValue);
  }
  return newString;
};

const ProPageStrings = {
  START_TRANSLATE: 'START_TRANSLATE',
  // todo: need a better schema for these things. grouping new under this object for now.
  headText: 'Make the most of the outdoors with Pro',
  featuresCollapseHead: 'Features designed for all',
  featuresList: [
    'Download maps to stay on track without service',
    'Never miss a turn with off-route notifications',
    'Keep friends and family informed with Lifeline',
    'Know what to expect with real-time map overlays',
    '1% of every subscription goes back to the planet'
  ],
  swiperText: 'Learn more about Pro',
  planTypeText: {
    headText: 'Pick your plan',
    submitText: 'Get Started',
    footText: 'Cancel within 30 days and receive a full-refund.'
  },
  planDetails: {
    annual: '/month - billed annually at',
    annualOnce: '/month - billed once at',
    annualDiscounted: '/month - 1st year billed at',
    threeYr: '/month - billed once at'
  },
  planTypeTitles: {
    annualOnce: 'Annual Plan',
    annual: 'Annual Plan',
    threeYr: 'Three-Year Plan'
  },
  discountText: {
    threeYr: 'Save 33%'
  },
  formText: {
    loginLead: 'Already have an account?',
    login: 'Log in',
    privacyPolicyLead: 'By continuing to use AllTrails, you agree to our',
    termsLink: 'Terms of Service',
    and: 'and',
    privacy: 'Privacy Policy',
    dividerText: 'or'
  },
  loginText: {
    headText: "Log in and let's get going",
    stepText: 'Step 2 of 3',
    forgotPassword: 'Forgot your password?',
    noAccount: "Don't have an account?",
    signUpFree: 'Sign up for free'
  },
  altLoginsText: {
    appleLogin: 'Continue with Apple',
    facebookLogin: 'Continue with Facebook',
    googleLogin: 'Continue with Google'
  },
  registrationText: {
    headText: 'Create your free account',
    stepText: 'Step 2 of 3',
    forgotPassword: 'Forgot your password?',
    register: 'Sign up'
  },
  forgotPasswordText: {
    headText: 'Forgot your password?',
    stepText: 'Enter your email to get help logging in.',
    sendEmail: 'Send email',
    backSignIn: 'Back to sign in',
    foot:
      'Note: The password reset email may take a few minutes. If you don\'t see it then, please check your "Promotions" tab and spam folder. If you are resubmitting this form, please note that any previous password reset emails you have requested will not work.'
  },
  resetPasswordText: {
    headText: 'Reset your password',
    stepText: 'Enter your new password below. It must be at least 6 characters long'
  },
  paymentText: {
    serverError: 'There was an error processing your payment. Please contact support.',
    creditCard: 'Credit Card',
    payByCreditCard: 'Pay by credit card',
    couponCode: 'Coupon Code',
    headText: 'Almost Done!',
    stepText: 'Step 3 of 3',
    changePlanText: 'Change Plan',
    submitText: 'Get AllTrails Pro',
    chooseMethodHead: 'Choose your payment method:',
    chooseMethodPrompt: 'By clicking an option below you will be redirected to either PayPal or Apple Pay to complete your purchase.   ',
    applyText: 'Apply',
    removeText: 'Remove',
    showCouponCodeText: 'Have a coupon code?',
    checkoutWith: 'Checkout with',
    enterBillingInformation: 'Enter billing information',
    threeYearFootText:
      'The 3-year subscription is a one time purchase that does not renew. After 36 months, your subscription will expire and you will have the option to re-upgrade.',
    footText: {
      lead: 'Note: you will be charged',
      mid: 'today and automatically renew after',
      tail: 'months unless you update your renewal settings.',
      discountMid: 'months at',
      discountTail: 'unless you update your renewal settings.'
    },
    getFootText: (amount, duration) => {
      return `Note: you will be charged ${amount} today and automatically renew after ${duration} months unless you update your renewal settings.`;
    },
    noAccount: "Don't have an acount?",
    signUpFree: 'Sign up for free'
  },
  loginForm: {
    email: {
      title: 'Email',
      validation: {
        generic: 'Email is not valid.'
      }
    },
    firstName: {
      title: 'First name',
      validation: {
        generic: 'Enter your first name.'
      }
    },
    lastName: {
      title: 'Last name',
      validation: {
        generic: 'Enter your last name.'
      }
    },
    password: {
      title: 'Password',
      validation: {
        generic: 'Password must be 6 characters long.'
      }
    }
  },
  confirmPassword: {
    title: 'Confirm Password',
    validation: {
      generic: "Passwords don't match"
    }
  },
  creditCardForm: {
    name: {
      title: 'Cardholder name',
      validation: {
        generic: "Please enter the cardholder's name.",
        lastName: "Cardholder's name must include a valid last name."
      }
    },
    number: {
      title: 'Card number',
      validation: {
        generic: 'Invalid card number'
      }
    },
    month: {
      title: 'Month',
      validation: {
        generic: 'Invalid expiration date'
      }
    },
    year: {
      title: 'Year',
      validation: {
        generic: 'Invalid expiration date'
      }
    },
    cvv: {
      title: 'CVV',
      validation: {
        generic: 'Enter CVV Code'
      }
    },
    postalCode: {
      title: 'Zip code',
      validation: {
        generic: 'Invalid Postal Code'
      }
    },
    couponCode: {
      title: 'Coupon Code',
      validation: {
        generic: 'This coupon code is invalid'
      }
    }
  },
  END_TRANSLATE: 'END_TRANSLATE'
};

export { StringConstantsMixin, ProPageStrings, replaceStrings };
